const MFA_LOGIN = 'MFA_LOGIN';
const MFA_SETUP = 'MFA_SETUP';
const NORMAL_LOGIN = 'NORMAL_LOGIN';

const styles = {
    linkButton: {
        height: '20px',
        marginTop: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    heading: {
        textAlign: 'center',
        fontSize: '2xl',
        lineHeight: '1.2',
        fontWeight: 'semibold',
    },
    buttonContainer: {
        display: 'flex',
        flexDir: 'column',
        w: '100%',
    },
    authAnimatedBox: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
};

// Animation variants for multidimensional transitions
const slideVariants = {
    initial: (direction) => ({
        x: direction === 'right' ? 100 : direction === 'left' ? -100 : 0,
        opacity: 0,
    }),
    animate: {
        x: 0,
        opacity: 1,
    },
    exit: (direction) => ({
        x: direction === 'right' ? -100 : direction === 'left' ? 100 : 0,
        opacity: 0,
    }),
};

const transition = {
    type: 'tween',
    duration: 0.45,
    ease: 'easeOut',
};

export {
    MFA_LOGIN,
    MFA_SETUP,
    NORMAL_LOGIN,
    styles,
    slideVariants,
    transition,
};
